import React from "react";
import ReactECharts from "echarts-for-react";
import { COLORS } from "../mockData";

const hexToRgb = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `${r}, ${g}, ${b}`;
};

const PatientScoreTrendChart = ({ title, xAxis = [], series = {}, color, label }) => {
  const data = series.data || [];
  const rgb = hexToRgb(color);

  const needsRotation = xAxis.length > 6;
  const rotateAngle = needsRotation ? 35 : 0;

  const option = {
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        if (!params?.length) return "";
        const p = params[0];
        const val = p.value != null ? p.value : "N/A";
        return `<strong>${p.axisValue}</strong><br/>${p.marker} ${label}: ${val}`;
      },
    },
    legend: {
      data: [label],
      top: 0,
      right: 0,
      icon: "rect",
      itemWidth: 12,
      itemHeight: 12,
      textStyle: { color: COLORS.body, fontSize: 12 },
    },
    grid: {
      left: 50,
      right: "4%",
      bottom: needsRotation ? 80 : 50,
      top: "14%",
      containLabel: false,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: xAxis,
      axisLine: { lineStyle: { color: COLORS.border } },
      axisLabel: {
        color: COLORS.body,
        fontSize: 10,
        rotate: rotateAngle,
        overflow: "truncate",
      },
      name: "Follow-up timepoints",
      nameLocation: "middle",
      nameGap: needsRotation ? 60 : 30,
      nameTextStyle: { color: COLORS.body, fontSize: 11 },
    },
    yAxis: {
      type: "value",
      axisLine: { show: true, lineStyle: { color: COLORS.border } },
      splitLine: { lineStyle: { color: COLORS.border, type: "dashed" } },
      axisLabel: { color: COLORS.body, fontSize: 11 },
      name: "Score",
      nameLocation: "middle",
      nameGap: 35,
      nameTextStyle: { color: COLORS.body, fontSize: 11 },
    },
    series: [
      {
        name: label,
        type: "line",
        smooth: false,
        connectNulls: false,
        symbol: "circle",
        symbolSize: 7,
        lineStyle: { color, width: 2 },
        itemStyle: { color },
        areaStyle: {
          color: {
            type: "linear",
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: `rgba(${rgb}, 0.35)` },
              { offset: 1, color: `rgba(${rgb}, 0.05)` },
            ],
          },
        },
        data,
      },
    ],
  };

  const chartHeight = needsRotation ? 280 : 240;

  return (
    <div className="patient-score-trend-chart">
      <h6 className="patient-score-trend-title">{title}</h6>
      <ReactECharts option={option} style={{ height: chartHeight, width: "100%" }} />
    </div>
  );
};

export default PatientScoreTrendChart;
